// extracted by mini-css-extract-plugin
export default {"wrapper":"areaTargetBox_wrapper__ShDS-","areaWrapper":"areaTargetBox_areaWrapper__dClyR"};